

























































import Vue from 'vue';

const avatarColors = [
    '#01D3DA',
    '#FCC800',
    '#00C48C',
    '#676F93',
    '#0084F4',
    '#F96246',
    '#F9624680',
    '#00C48C80',
    '#0084F480',
];

export default Vue.extend({
    props: {
        value: {
            required: false,
        },
        width: {
            required: false,
            type: String,
        },
        avatar: {
            required: false,
            type: String,
            default: '',
        },
        clickable: {
            required: false,
            type: Boolean,
        },
    },
    data() {
        return {
            page: 1,
            pageCount: 0,
            itemsPerPage: 10,
            totalVisible: 7,
            avatarColors,
        };
    },
    methods: {},
});
